<template>
  <Modal width="600" v-model="show" title="报名" :footer-hide="true" :centered="true" @cancel="show = false">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="100" class="forms">
      <FormItem label="团队名称：" prop="team_name" v-if="type === 2">
        <Input placeholder="请输入团队名" v-model="formData.team_name" />
      </FormItem>
      <FormItem label="团队角色：" v-if="type === 2">
        <RadioGroup v-model="formData.role" @on-change="changeRole($event)">
          <Radio :label="1">
            <span>参赛队长</span>
          </Radio>
          <Radio :label="2">
            <span>参赛指导</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <div v-if="type === 2" class="pl18">本赛事需团队报名，团队人数{{ min }}-{{ max }}人，请填写团队成员信息。</div>
      <div class="stu_info" v-for="(item, index) in formData.user_list" :key="index">
        <div class="head" v-if="type === 2">
          <span class="section">成员{{ index + 1 }}</span>
          <span v-if="index > 1" class="del" @click="delStudent(index)">删除</span>
        </div>
        <div class="nav">
          <FormItem label="成员姓名：">
            <Input placeholder="请输入成员姓名" v-model="item.name" :disabled="(index === 0 && formData.role === 1) || type === 1" />
          </FormItem>
          <FormItem label="身份证号：">
            <Input placeholder="请输入身份证号" v-model="item.id_card" :disabled="(index === 0 && formData.role === 1) || type === 1" />
          </FormItem>
        </div>
      </div>
      <div class="add_stud" v-if="type === 2" @click="addStudent()">
        + 增加成员
      </div>
    </Form>
    <div class="ivu-modal-footer">
      <Button @click="cancleForm('formData')">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { Form, Modal, FormItem, Input, Message, RadioGroup, Radio } from 'view-design'
export default {
  components: {
    Modal,
    Form,
    FormItem,
    Input,
    RadioGroup,
    Radio
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 2
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      authInfo: {},
      formData: {
        team_name: '',
        role: 1, //1 队长 2指导
        user_list: [{ id_card: '', name: '' }]
      },
      nameFlag: true,
      cardFlag: true,
      cardFlagTrue: true,
      reg: /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/,
      rules: {
        team_name: [
          {
            required: true,
            message: '请输入团队名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 是否展示弹窗
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.formData = {
          team_name: '',
          user_list: [{ id_card: '', name: '' }]
        }
      } else {
        this.authInfo = JSON.parse(localStorage.getItem('userAuthInfo')) || {}
        // 多人赛
        if (this.type === 2) {
          console.log(this.list[0], '111')
          this.formData = {
            team_name: this.list[0] ? this.list[0].team_name : '',
            role: this.list[0] && this.authInfo.id_card !== this.list[0].id_card ? 2 : this.authInfo?.id_card === this.list[0]?.id_card ? 1 : 1,
            user_list:
              this.list.length > 0
                ? this.list
                : [
                    { id_card: this.authInfo.id_card, name: this.authInfo.name },
                    { id_card: '', name: '' },
                    { id_card: '', name: '' }
                  ]
          }
        } else {
          this.formData = {
            user_list: [{ id_card: this.authInfo.id_card, name: this.authInfo.name }]
          }
        }
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    changeRole(e) {
      if (e === 1) {
        this.formData.user_list.unshift({ id_card: this.authInfo.id_card, name: this.authInfo.name })
      } else {
        this.formData.user_list.shift()
      }
    },
    // 验证是否存在信息没有填写
    checkInfo() {
      this.formData.user_list.map(item => {
        if (item.name === '') {
          this.nameFlag = false
        }
        if (item.id_card === '') {
          this.cardFlag = false
        }
        if (!this.reg.test(item.id_card)) {
          this.cardFlagTrue = false
        }
      })
    },
    // 删除学生
    delStudent(index) {
      this.formData.user_list.splice(index, 1)
    },
    // 添加学生
    addStudent() {
      if (this.formData.user_list.length < this.max) {
        this.formData.user_list.push({ id_card: '', name: '' })
      } else {
        Message.warning('已达到最高人数')
      }
    },
    cancleForm(name) {
      this.show = false
      this.$refs[name].resetFields()
    },

    // 提交
    handleSubmit(name) {
      console.log(this.formData)
      this.$refs[name].validate(valid => {
        if (valid) {
          this.nameFlag = true
          this.cardFlag = true
          this.cardFlagTrue = true
          this.checkInfo()
          if (this.nameFlag === false) {
            Message.error('存在成员姓名未填写')
            return
          }
          if (this.cardFlag === false) {
            Message.error('存在成员身份证号未填写')
            return
          }
          if (this.cardFlagTrue === false) {
            Message.error('存在错误的身份证号')
            return
          }
          this.signUp()
        }
      })
    },
    // 报名
    async signUp() {
      const userId = JSON.parse(localStorage.getItem('userInfo')).uid
      const params = {
        uriCode: 'API009',
        ...this.formData,
        cf_id: Number(this.$route.query.id),
        uid: userId
      }
      try {
        await this.$fetch(params)
        Message.success('报名成功！')
        this.$emit('ok')
      } finally {
        this.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.ivu-input {
  width: 94%;
}
/deep/.forms {
  max-height: 400px;
  overflow-y: auto;
}
.pl18 {
  padding-left: 18px;
}
.stu_info {
  font-size: 14px;
  border: 1px solid #e9e9e9;
  margin-top: 10px;
  .head {
    background: #f7f9fb;
    line-height: 48px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    border-bottom: 1px solid #e9e9e9;
    .del {
      color: #f5222dff;
      cursor: pointer;
    }
    .del:hover {
      opacity: 0.9;
    }
  }
  .nav {
    padding-top: 24px;
  }
}
.add_stud {
  width: 80%;
  line-height: 32px;
  border: 1px solid #e9e9e9;
  background: #f7f9fb;
  color: #1890ffff;
  cursor: pointer;
  margin: 10px auto;
  text-align: center;
}
.add_stud:hover {
  background: #d8e5f3;
}
</style>
